import {
  SERVICE_LIST_SET_SELECTED_REGION,
  SERVICE_LIST_SUCCESS
} from '../constants'

type IServiceListReducer = {
  businessListData: {}
  selectedRegion: any
}

const initialState: IServiceListReducer = {
  businessListData: {},
  selectedRegion: {}
}

const ServiceListReducer = (
  state: IServiceListReducer = initialState,
  action
): IServiceListReducer => {
  switch (action.type) {
    case SERVICE_LIST_SUCCESS:
      return {
        ...state,
        businessListData: action.payload
      }

    case SERVICE_LIST_SET_SELECTED_REGION:
      return {
        ...state,
        selectedRegion: action.payload
      }

    default:
      return state
  }
}

export default ServiceListReducer
